<template>
  <div>
    <validation-observer ref="channelForm">
      <b-form
        @submit.prevent=""
        @reset.prevent="resetForm"
      >
        <validation-provider
          #default="validationContext"
          name="Tiêu đề"
          vid="name"
          rules="required"
        >
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Tiêu đề <span class="text-danger">*</span></label>
            </template>
            <b-form-input
              id="name"
              v-model="frmData.name"
              type="text"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..."
            />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider
          #default="validationContext"
          name="Nội dung"
          vid="content"
          rules="required"
        >
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Nội dung<span class="text-danger">*</span></label>
            </template>
            <b-form-textarea
              v-model="frmData.content"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..."
            />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-group>
          <!-- ATTACH ORIGINAL FILE -->
          <upload-form
            :attached-files="frmData.attach_file"
            @update-attached-files="onUpdateAttachedFiles"
          />
        </b-form-group>
        <div class="row">
          <div class="col-12 col-md-6">
            <validation-provider
              #default="validationContext"
              vid="start_date"
              name="Thời gian bắt đầu"
              rules="required"
            >
              <b-form-group
                label="Thời gian bắt đầu"
                class="mb-0"
                label-for="start_date"
              >
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Thời gian bắt đầu<span class="text-danger">*</span></label>
                </template>
                <flat-pickr
                  v-model="frmData.start_date"
                  class="form-control"
                  :config="config_date"
                  placeholder="dd-mm-yyyy hh:i"
                  theme="dark"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-12 col-md-6">
            <validation-provider
              #default="validationContext"
              vid="end_date"
              name="Thời gian kết thúc"
              rules="required"
            >
              <b-form-group
                label="Đến ngày"
                class="mb-0"
                label-for="end_date"
              >
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Thời gian kết thúc<span class="text-danger">*</span></label>
                </template>
                <flat-pickr
                  v-model="frmData.end_date"
                  class="form-control"
                  :config="config_date"
                  variant="secondary"
                  themes="dark"
                  placeholder="dd-mm-yyyy hh:i"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12">
            <b-form-checkbox
              v-model="frmData.status"
              value="1"
              class="custom-control-primary"
            > Kích hoạt </b-form-checkbox>
          </div>
        </div>
        <div class="d-flex mt-1">
          <b-button
            variant="primary"
            type="submit"
            @click.prevent="validationForm"
          >
            <feather-icon icon="SaveIcon" /> {{ $t('Save') }} </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BFormTextarea,
} from 'bootstrap-vue';
import formValidation from '@core/comp-functions/forms/form-validation';
import { showToast, useRouter } from '@core/utils/utils';
import { getToken } from '@/auth/utils';
import store from '@/store';
import {
  required, email, alphaNum, min, max,
} from '@validations';
import UploadForm from './UploadForm.vue';

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    UploadForm,
    flatPickr,
  },
  props: {
    dataEdit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      email,
      alphaNum,
      min,
      max,
      api_upload: `${process.env.VUE_APP_NEWS_API_URL}manager/upload`,
    };
  },
  setup(props, context) {
    const accessToken = getToken();
    const files_content = ref([]);
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });
    const custom_data = ref({
      upload_status: 1,
    });
    const { route, router } = useRouter();
    const blankData = {
      name: '',
      content: '',
      attach_file: [],
      start_date: '',
      end_date: '',
      status: 0,
    };
    const today = new Date();
    const hour = today.getHours();
    const minute = today.getMinutes();
    const current_date = `${today.getDay()}-${today.getMonth}-${today.getFullYear}`;
    const frmData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData));
    };
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit;
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(frmData);
    const config_date = ref({
      dateFormat: 'd-m-Y H:i',
      enableTime: true,
      locale: Vietnamese, // locale for this instance only
      defaultHour: hour,
      time_24hr: true,
      theme: 'dark',
    });
    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
      config_date,
      custom_header,
      custom_data,
      files_content,
    };
  },
  methods: {
    onUpdateAttachedFiles(attachedFiles) {
      this.frmData.attach_file = attachedFiles
    },
    onSubmit() {
      if (this.frmData.id) {
        store
          .dispatch('notification/update', {
            data: this.frmData,
            id: this.frmData.id,
          })
          .then((response) => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData();
            } else if (result.errors) {
              this.$refs.channelForm.setErrors(result.errors);
            } else {
              showToast(result.message);
            }
          });
      } else {
        store.dispatch('notification/create', this.frmData).then((response) => {
          const result = response.data;
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.$emit('updateList');
            this.resetfrmData();
          } else if (result.errors) {
            this.$refs.channelForm.setErrors(result.errors);
          } else {
            showToast(result.message);
          }
        });
      }
    },
    validationForm() {
      this.errorMessage = {};
      this.$refs.channelForm.validate().then((success) => {
        if (success) {
          this.onSubmit();
        }
      });
    },
    onDelete(file) {
      if (this.frmData.attach_file.length > 0) {
        const files = this.frmData.attach_file.filter((item) => item.file_id != file.file_id)
        this.$refs.upload.remove(file);
        this.frmData.attach_file = files;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      // if (newFile && !oldFile) {
      //   if (
      //     !/\.(jpeg|jpe|jpg|gif|png|webp|mp3|mp4|wav|webm)$/i.test(newFile.name)
      //   ) {
      //     this.$swal({
      //       title: '',
      //       html: '<b>Chỉ hỗ trợ định dạng:</b> jpg, png, jpeg, git, webp, mp3, wav, mp4, webm',
      //       allowOutsideClick: true,
      //       customClass: {
      //         confirmButton: 'btn btn-primary',
      //       },
      //       buttonsStyling: false,
      //     });
      //     return prevent();
      //   }
      // }
    },
    inputFile(newFile, oldFile) {
      if (
        Boolean(newFile) !== Boolean(oldFile)
        || oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }

      if (newFile && newFile.error && newFile.response.code) {
        newFile.error = newFile.response.message;
      }
      if (newFile && newFile.success && newFile.response.code !== 200) {
        showToast('Không tải được file lên server');
        newFile.error = 'Không tải được file lên server';
      }
      if (newFile && newFile.success && newFile.response.code === 200) {
        newFile.file_id = newFile.response.data.id;
        this.frmData.attach_file.push(newFile.response.data);
      }
    },
    formatFileSize(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
  },
};
</script>
<style lang="scss">
.btnUpload {
  label {
    cursor: pointer;
  }
}

.attach_file {
  margin: 0;

  li {
    padding: 2px 0;
  }

  .trash {
    cursor: pointer;
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
